import React from 'react';

export default function FullScreenSpinner() {
    return (
        <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-900 tw-bg-opacity-75 tw-z-50">
            <div className="tw-w-16 tw-h-16 tw-border-4 tw-border-white tw-border-t-transparent tw-rounded-full tw-animate-spin"></div>
        </div>
    );
}
